import { render, staticRenderFns } from "./shortcut.vue?vue&type=template&id=265ba64c"
import script from "./shortcut.ts?vue&type=script&lang=js&external"
export * from "./shortcut.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('265ba64c')) {
      api.createRecord('265ba64c', component.options)
    } else {
      api.reload('265ba64c', component.options)
    }
    module.hot.accept("./shortcut.vue?vue&type=template&id=265ba64c", function () {
      api.rerender('265ba64c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/shortcut/shortcut.vue"
export default component.exports